import { QueryClient } from "@tanstack/react-query";

// Shared client so auth flows can clear cached data on login/logout
// (prevents one user's data leaking into another's session on shared devices).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
